module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Icon/copy_icon-a9cf284123269006a9a5b56bc686fd80.svg";